// src/components/Header.js
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";    // make sure this points at the right file
import Login from "./Login";
import logo from "../styles/Logo.png";
import "../styles/Header.css";

export default function Header({ darkMode, toggleDarkMode }) {
  const { isAuthenticated, showLogin, setShowLogin, login, logout } = useAuth();

  return (
    <>
      <header className="header">
        <div className="nav-left">
          <Link to="/" className="nav-logo">
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>
        </div>

        <div className="nav-right">

          {isAuthenticated ? (
            <div className="user-profile">
              {/* You can show user name or avatar here if you wire it up */}
              <button onClick={logout} className="logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <button
              onClick={() => setShowLogin(true)}
              className="login-btn"
            >
              Login
            </button>
          )}
        </div>
      </header>

      {/* Login modal */}
      {showLogin && (
        <Login
          onClose={() => setShowLogin(false)}
          onSuccess={userData => {
            login(userData);      // hook into your real login flow
          }}
        />
      )}
    </>
  );
}
